export const fallback = "en";
export const translations = {
    en: {
        "left" : "Left",
        "offersDiscount" : "Offers Discount",
        "endOffers" : "This offer will go away soon",
        "offers" : "Offers",
        "clickOffers": "Click here to see the offers!",
        "outOfStock": "Out Of Stock",
        "until": "Until",
        'am': "am",
        'pm': "pm",
        "sunday"    : "Sunday",
        "monday"    : "Monday",
        "tuesday"   : "Tuesday",
        "wednesday" : "Wednesday",
        "thursday"  : "Thursday",
        "friday"    : "Friday",
        "saturday"  : "Saturday",
        "everyday"  : "Sunday - Saturday",
        'apply'     : "Apply",
        'showMore'  : "Show more",
        'priceSelection' : "Price on selection",
        'tempClosed' : "Sorry! we're temporarily closed",
        'failed' : "Payment failed!",
        'deliveryUpText'  : "Help our driver find you faster by providing an accurate location",
        'saveLocation'  : "Save Location",
        'addDelivery'   : "Add Delivery Details",
        'area'          : "Area",
        'orderNow'   :"Order Now",
        'asSoonAs'   :"As soon as possible",
        'startOrdering' : "Start Ordering",
        'linkedin'  : "LinkedIn",
        'telegram'  : "Telegram",
        'facebook'  : "Facebook",
        'twitter'   : "Twitter",
        'snapchat'  : "Snapchat",
        'instagram' : "Instagram",
        'whatsapp'  : "Whatsapp",
        'scheduledTime' : "Scheduled Time",
        'search'    : "Search",
        'status'    : "Status",
        'menu'      : "Menu",
        'branches'  : "Branches",
        'orderStatus' : "Order Status",
        'otherLinks'  : "OTHER LINKS",
        'delivery'    : "Delivery",
        'currency' : {
            'kwd' : "KWD",
        },
        'setTime'    : "Set Time",
        'orderMode'  : "Order Mode",
        'price'      : "Price",
        'addToOrder' : "Add to Order",
        'selectUpto' : "Select Upto",
        'items'         : "Items",
        'required'      : "Required",
        'reviewOrder'   : "Review Order",
        'remove'        : "Remove",
        'deliveryInfo'  : "Delivery Info",
        'orderItems'    : "Order Items",
        'promoCode'     : "Promo Code",
        'apply'         : "Apply",
        'invalidPromo'  : "Your promo code is invalid",
        'promoDiscount' : "Promo Discount",
        'total'         : "Total",
        'goToCheckout'    : "Go to Checkout",
        'checkout' : "Checkout",
        'payCash' : "Cash",
        'next' : "Next",
        'searchItems' : "Search Items",
        'cancel' : "Cancel",
        'findProducts': "Find Products",
        'typein' : "Type in what you are looking for",
        "order look up" : "Order Look Up",
        'orderCode'     : "Order Code",
        'lookUpOrder'   : "Look Up Order",
        'orderSMS'     : "Order code can be found in SMS messages, after placing an order.",
        'callBranch'   : "Call Branch",
        'getDirection' : "Get Directions",
        'contactInfo'  : "Contact Info",
        'contactText'  : "We’ll use it to get back to you for order updates",
        'name'      : "Name",
        'email'  : "Email",
        "phone"  : "Phone",
        "deliveryAddress" : "Delivery Address",
        "detectLoc"     : "Detect Location",
        "tapToEdit"     : "Tap to edit location",
        "deliveryText"  : "Precise location will help reach you faster",
        "chooseUnit"    : "Choose Unit Type",
        "house":"House",
        "office":"Office",
        "appartment":"Appartment",
        "block":"Block",
        "street":"Street",
        "building":"Building",
        "avenue":"Avenue (Optional)",
        "floor":"Floor",
        "instructions":"Special Directions (Optional)",
        "paymentMethod":"Payment Method",
        "paymentMethodText":"Choose your preferred payment method",
        "knet":"KNET",
        "finalize":"Finalize",
        "searchCities" : "Search in cities",
        "selectmany" : "Choose x of the choices.",
        "selectmiddle" : "Choose x as minimum up to xx maximum",
        "houseNo" : "House No.",
        "officeNo" : "Office No.",
        "appartmentNo" : "Appartment No.",
        "card" : "Visa/MC",
        "knetMachine" : "KNET Machine",
        "orderItems" : "Order Items",
        "total" : "Total",
        "today" : "Today",
        "tomorrow" : "Tomorrow",
        "scheduleOrder" : "Order Later",
        "pickup": "Pickup",
        "branch": "Branch",
        "thankYou": "Thank You!",
        "orderPlaced" : "Your order is placed successfully",
        "viewReceipt" : "View Receipt",
        "getHelp"     : "Get Help",
        "startOver"   : "Start Over",
        "confirmingOrder" : "Confirming your order",
        "orderReceipt"   : "Order Receipt",
        "closed" : "Closed",
        "open" : "Open",
        "orderDetails": "Order Details",
        "tax": "Tax",
        "estimatedTime" : "Estimated Time",
        "minOrder" : "Minimum required amount",
        'failedText' : "Your order could not be proceed, please try again.",
        'tryAgain' : "Try again",
        'kuwait' : "Kuwait",
        'oman'   : "Oman",
        'uae'    : "United Arab Emirates",
        'saudia' : "Saudia Arabia",
        'qatar'  : "Qatar",
        'bahrain': "Bahrain",
        'poweredby': "Powered by",
    },
    ar: {
        "poweredby" : "مشغل بواسطة",
        "left" : "Left",
        "clickOffers": "Click here to see the offers!",
        "endOffers" : "This offer will go away soon",
        "offers" : "Offers",
        "outOfStock": "إنتهى من المخزن",
        'until': "حتى",
        'am': "ص",
        'pm': "م",
        "sunday"    : "الأحد",
        "monday"    : "الاثنين",
        "tuesday"   : "الثلاثاء",
        "wednesday" : "الأربعاء",
        "thursday"  : "الخميس",
        "friday"    : "الجمعة",
        "saturday"  : "السبت",
        "everyday"  : "السبت - الأحد",
        'apply'     : "Apply",        'showMore'  : "أظهر المزيد",
        'priceSelection' : "السعر حسب الاختيار",
        'Order Now'   :"الطلب الآن",
        'orderNow'   :"الطلب الآن",
        'tempClosed' : "عذراً! المتجر مغلق موقتاً",
        'kuwait' : "Kuwait",
        'oman'   : "Oman",
        'uae'    : "United Arab Emirates",
        'saudia' : "Saudia Arabia",
        'qatar'  : "Qatar",
        'bahrain': "Bahrain",
        'tryAgain' : "إعادة الدفع",
        'failedText' : "نعتذر لعدم تنفيذ طلبك، من فضلك حاول مرة أخرى.",
        'failed' : "فشلت عملية الدفع!",
        "minOrder" : "الحد الأدنى للطلب",
        'deliveryUpText'  : "حدد موقعك بشكل دقيق ليساعدنا في إيصال الطلب لك بأسرع وقت ممكن",
        'saveLocation'  : "حفظ الموقع",
        'addDelivery'   : "إضافة تفاصيل للتوصيل",
        "estimatedTime" : "الوقت المُقدّر",
        "orderDetails": "",
        "tax": "ضريبة",
        "open" : "مفتوح",
        "closed" : "مغلق",
        "branch": "الفرع",
        "thankYou": "شكراً لطلبك!",
        "orderPlaced" : "تم إرسال الطلب بنجاح",
        "viewReceipt" : "مشاهدة الفاتورة",
        "getHelp"     : "طلب مساعدة",
        "startOver"   : "البداية من جديد",
        "confirmingOrder" : "تأكيد طلبك",
        "orderReceipt"   : "تفاصيل الطلب",
        "pickup": "استلام",
        "scheduleOrder" : "الطلب في وقت آخر",
        "today" : "اليوم",
        "tomorrow" : "غداً",
        "total" : "المجموع",
        "orderItems" : "تفاصيل الطلب",
        "houseNo" : "رقم المبنى",
        "officeNo" : "رقم المكتب",
        "appartmentNo" : "رقم الشقة",
        "selectmany" : "اختر عدد x من الخيارات التالية.",
        "selectmiddle" : "يمكن اختيار x كحد أدنى - إلى xx كحد أقصى.",
        'area'      : "المنطقة",
        'asSoonAs'   :"في أقرب وقت ممكن",
        'startOrdering' : "اطلب الآن",
        'linkedin'  : "لينكدإن",
        'telegram'  : "تيليغرام",
        'facebook'  : "فيسبوك",
        'twitter'   : "تويتر",
        'snapchat'  : "سناب جات",
        'instagram' : "انستقرام",
        'whatsapp'  : "واتسب",
        'scheduledTime' : "وقت التوصيل",
        'search'    : "بحث",
        'status'    : "الحالة",
        'menu'      : "القائمة",
        'branches'  : "الأفرع",
        'orderStatus' : "حالة الطلب",
        'otherLinks'  : "روابط أخرى",
        'delivery'    : "التوصيل",
        'currency' : {
            'kwd' : "د.ك",
        },
        'setTime'    : "اختر الوقت",
        'orderMode'  : "حالة الطلب",
        'price'      : "السعر",
        'addToOrder' : "إضافة للسلة",
        'selectUpto' : "إختر إلى",
        'items'         : "الطلبات",
        'required'      : "مطلوب",
        'reviewOrder'   : "مشاهدة الطلب",
        'remove'        : "حذف",
        'deliveryInfo'  : "تفاصيل التوصيل",
        'orderItems'    : "تفاصيل الطلب",
        'promoCode'     : "كود الخصم",
        'apply'         : "استخدم",
        'invalidPromo'  : "الكود المدخل غير صالح!",
        'promoDiscount' : "عرض الخصم",
        'total'         : "المجموع",
        'goToCheckout'    : "إذهب للدفع",
        'checkout' : "الدفع",
        'payCash' : "كاش",
        'next' : "متابعة",
        'searchItems' : "البحث عن منتج",
        'cancel' : "إلغاء",
        'findProducts': "المنتجات المتوفرة",
        'typein' : "اكتب ماذا تبحث عنه",
        "order look up" : "تفاصيل الطلب",
        'orderCode'     : "رقم الطلب",
        'lookUpOrder'   : "متابعة الطلب",
        'orderSMS'     : "بعد إتمامك للطلب سيصلك رقم الطلب برسالة نصية لإستخدامه في متابعة الطلب",
        'callBranch'   : "اتصل بالفرع",
        'getDirection' : "تتبع الموقع",
        'contactInfo' : "بيانات الإتصال",
        'contactText' : "سنستخدم هذه البيانات للتواصل معك فور التحديث على الطلب",
        'name' : "الإسم",
        'email' : "البريد الإلكتروني",
        "phone" : "رقم الهاتف",
        "deliveryAddress" : "عنوان التوصيل",
        "detectLoc" : "تحديد موقعي",
        "tapToEdit" : "اضغط لتحديد الموقع",
        "deliveryText" : "الموقع الدقيق سوف يساعد على تحديد موقعك",
        "chooseUnit" : "اختر نوع المكان",
        "house":"منزل",
        "office":"مكتب",
        "appartment":"شقة",
        "block":"قطعة",
        "street":"شارع",
        "building":"مبنى",
        "avenue":"جادة (اختياري)",
        "floor":"الطابق",
        "instructions":"وصف محدد (اختياري)",
        "paymentMethod":"طريقة الدفع",
        "paymentMethodText":"اختر طريقة الدفع المناسبة لك",
        "knet":"كي نت",
        "finalize":"تنفيذ",
        "searchCities" : "ابحث في المناطق",
        "card" : "بطاقة إئتمانية",
        "knetMachine" : "جهاز كي نت"
    }
};
